import React, { memo, useEffect, useState } from 'react'
import { isEmpty, map } from 'lodash'

import { useAuthentication } from 'utils/authentication'
import Loader from 'components/Loaders'
import Block from './Block'
import { Tool, GroupedTools } from '__generated__/api-types-and-hooks'
import { ToolConnectionInputFormModal } from './ToolConnectionInputFormModal'
import { ReduxAction } from '../../../store/types'
import ToolsWrapper from './ToolsWrapper'
import { useFlashParams } from '../../../hooks/useFlashParams'

interface IAllToolsProps {
  allTools: GroupedTools[]
  oAuthUrl: string
  getMyToolsAction
  allToolsLoading
  getAllToolsAction
  resetOAuthUrlAction
  getUserConnectorsAction
  getOAuthUrlAction
  deauthenticateConnectorAction
  toolConnectionSuccessAction: ReduxAction<{ playId?: string; connectorName?: string }>
}
const AllTools = ({
  allTools,
  oAuthUrl,
  allToolsLoading,
  getAllToolsAction,
  resetOAuthUrlAction,
  toolConnectionSuccessAction,
  getUserConnectorsAction,
  getOAuthUrlAction,
  getMyToolsAction,
}: IAllToolsProps) => {
  const [activeConnectingTool, setActiveConnectingTool] = useState<Tool | null>(null)
  const [isInputPropertiesModalOpen, setInputPropertiesModalOpen] = useState(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { flashParams, removeFlashParams } = useFlashParams<{ connectorName: string }>()
  useEffect(() => {
    if (flashParams?.connectorName) {
      console.log('second')
      toolConnectionSuccessAction({ connectorName: flashParams.connectorName })
      removeFlashParams(['connectorName'])
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flashParams?.connectorName])

  useEffect(() => {
    getAllToolsAction()
    getUserConnectorsAction()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (activeConnectingTool?.options?.connectionForm?.inputProperties?.length) {
      setInputPropertiesModalOpen(true)
    }
  }, [activeConnectingTool, isInputPropertiesModalOpen])

  useAuthentication(oAuthUrl, getUserConnectorsAction, resetOAuthUrlAction)
  return (
    <>
      <ToolsWrapper label="All" isItemsGrouped={true}>
        {/* <Container> */}
        {allToolsLoading ? (
          <Loader loader={'ConnectedTools'} />
        ) : !allToolsLoading && isEmpty(allTools) ? (
          <p className="font-primary font-bold text-lg">No tools found.</p>
        ) : (
          map(allTools, (groupedTool: GroupedTools, index) => (
            <div className="mb-14" key={index}>
              <h3 className="text-3xl font-light  mb-4">{groupedTool.category}</h3>
              <div className="flex xs:items-start xs:justify-center sm:justify-start xs:gap-6 sm:gap-12 lg:gap-10 xs:flex-wrap min-h-[320px] overflow-y-auto pb-4">
                {groupedTool.tools?.map(
                  (tool) =>
                    tool?.visible && (
                      <Block
                        tool={tool!}
                        key={tool?.id}
                        setActiveConnectingTool={setActiveConnectingTool}
                        getOAuthUrlAction={getOAuthUrlAction}
                        onDisconnect={() => getMyToolsAction()}
                      />
                    )
                )}
              </div>
            </div>
          ))
        )}

        {isInputPropertiesModalOpen && activeConnectingTool ? (
          <ToolConnectionInputFormModal
            tool={activeConnectingTool}
            onClose={() => {
              setInputPropertiesModalOpen(false)
              setActiveConnectingTool(null)
              getAllToolsAction()
            }}
            getOAuthUrlAction={getOAuthUrlAction}
            oAuthUrl={oAuthUrl}
          />
        ) : (
          <></>
        )}
      </ToolsWrapper>
      {/* </Container> */}
    </>
  )
}

export default memo(AllTools)
